import { gql } from '@apollo/client'

export const GenerateProductSpecification = gql`
    mutation generateProductSpecification($listingId: String) {
        generateProductSpecification(listingId: $listingId) {
            downloadURI
            errorMessage
            listingId
        }
    }
`
